import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';

export type FiltersType = {
  field: string;
  values: Array<string>;
};

interface FiltersQueryParameters {
  field: string;
  form: string;
}

export type GetUserAppliedFiltersApiResponse = /** status 200 OK */ UserAppliedFiltersDto;
export type GetUserAppliedFiltersApiArg = void;
export type CreateUserAppliedFiltersApiResponse = /** status 200 OK */ string;
export type CreateUserAppliedFiltersApiArg = {
  userAppliedFiltersDto: UserAppliedFiltersDto;
};
export type HierarchyFiltersForView = {
  hierarchyValues?: {
    [key: string]: string[];
  };
  showArchived?: boolean;
};

export type DateFilterRangeType =
  | 'LAST_12_MONTHS'
  | 'CURRENT_YEAR'
  | 'AU_CURRENT_FISCAL_YEAR'
  | 'LAST_24_HOURS'
  | 'PREVIOUS_DAY'
  | 'LAST_7_DAYS'
  | 'PREVIOUS_WEEK'
  | 'PREVIOUS_MONTH'
  | 'CURRENT_MONTH'
  | 'PREVIOUS_YEAR'
  | 'AU_PREVIOUS_FISCAL_YEAR'
  | 'UK_CURRENT_FISCAL_YEAR'
  | 'UK_PREVIOUS_FISCAL_YEAR'
  | 'US_CURRENT_FISCAL_YEAR'
  | 'US_PREVIOUS_FISCAL_YEAR'
  | 'CU1_CURRENT_FISCAL_YEAR'
  | 'CU1_PREVIOUS_FISCAL_YEAR'
  | 'CU2_CURRENT_FISCAL_YEAR'
  | 'CU2_PREVIOUS_FISCAL_YEAR'
  | 'LAST_30_DAYS'
  | 'CUSTOM_FILTER_VALUE';

export type DateFilters = {
  dateFilterRangeType?: DateFilterRangeType;
  fromDate?: string;
  toDate?: string;
};
export type DashboardFilters = {
  hierarchyFilters?: HierarchyFiltersForView;
  dateFiltersForView?: DateFilters;
};
export type UserAppliedFiltersDto = {
  userId?: string;
  dashboardFiltersCombination?: DashboardFilters;
};

export const filtersApi = createApi({
  reducerPath: 'filtersApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ['UserAppliedFilters'],

  endpoints: (builder) => ({
    getFilters: builder.query<FiltersType, FiltersQueryParameters>({
      query: (args) => {
        let url = `/filters?field=${args.field}`;

        if (args.form) {
          url += `&form=${args.form}`;
        }

        return { url, method: 'GET' };
      },
    }),
    getUserAppliedFilters: builder.query<GetUserAppliedFiltersApiResponse, GetUserAppliedFiltersApiArg>({
      query: () => ({ url: `/user-applied-filters` }),
      providesTags: ['UserAppliedFilters'],
    }),
    createUserAppliedFilters: builder.mutation<CreateUserAppliedFiltersApiResponse, CreateUserAppliedFiltersApiArg>({
      query: (queryArg) => ({ url: `/user-applied-filters`, method: 'POST', body: queryArg.userAppliedFiltersDto }),
      invalidatesTags: ['UserAppliedFilters'],
    }),
  }),
});

export const {
  useGetFiltersQuery,
  useLazyGetFiltersQuery,
  useGetUserAppliedFiltersQuery,
  useLazyGetUserAppliedFiltersQuery,
  useCreateUserAppliedFiltersMutation,
} = filtersApi;
